import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './core/store/store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './core/i18n/i18n'
import { init } from './utils/globals/init'

import * as Sentry from '@sentry/react'

if (process.env.REACT_APP_ENV_NAME !== 'local') {
  Sentry.init({
    dsn: `${process.env.REACT_APP_SENTRY_DSN}`,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: ['localhost'],
      }),
    ],
    environment: process.env.REACT_APP_SENTRY_ENV_NAME || 'production',
    tracesSampleRate: 1.0,
  })
}

async function enableMocking() {
  if (process.env.REACT_APP_FOODBOX_MOCK) {
    const { worker } = await import('./mock/browser')
    return worker.start()
  }
}

init()

enableMocking().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ToastContainer />
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
})
